function StickyFooter(params) {
	if(!params) return;
	
	this.setDefaults(params);
	this.addListeners();
}

StickyFooter.prototype.setDefaults = function(params) {
	this.dom = {
		$container: $(params.container),
		$inner: $(params.inner),
		$header: $(params.header),
		$footer: $(params.footer)
	};
};

StickyFooter.prototype.addListeners = function() {
	$(window).on('scroll', this.reposition.bind(this));
};

StickyFooter.prototype.reposition = function() {
	var scrollTop = $(window).height() + $(window).scrollTop();

	var end = this.dom.$footer.offset().top + this.dom.$inner.height();
    
	var pos;
	if ($(window).scrollTop() > this.dom.$header.height() && scrollTop < end) {
		pos = 'fixed';
	} else {
		pos = 'relative';
	}

	this.dom.$inner.css('position', pos);
};

new StickyFooter({
	container: '.wp-sticky-footer',
	inner: '.wp-sticky-footer__inner',
	header: '.workforce-partnership-header',
	footer: 'footer'
});